import { render } from "./StudentCharts.vue?vue&type=template&id=05c39e0a&scoped=true"
import script from "./StudentCharts.vue?vue&type=script&lang=js"
export * from "./StudentCharts.vue?vue&type=script&lang=js"

import "./StudentCharts.vue?vue&type=style&index=0&id=05c39e0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c39e0a"]])

export default __exports__